<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" prefix-icon="el-icon-search" size="small"
                  style="width: 200px; margin-bottom: 0;"
                  class="filter-item" :placeholder="'关键字'" v-model="listQuery.key">
        </el-input>

        <!-- <el-button class="filter-item" type="success" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button> -->
        <permission-btn moduleName='usermanager' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>

        <el-checkbox size="mini" style='margin-left:15px;' @change='tableKey=tableKey+1' v-model="showDescription">
          Id/描述
        </el-checkbox>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <el-row :gutter="4" class="fh">
        <el-col :span="6" class="fh ls-border">
          <el-card shadow="never" class="body-small fh" style="overflow: auto">
            <div slot="header" class="clearfix">
              <el-button type="text" style="padding: 0 11px" @click="getAllUsers">全部用户>></el-button>
            </div>

            <el-tree :data="orgsTree" :expand-on-click-node="false" default-expand-all :props="defaultProps"
                     @node-click="handleNodeClick"></el-tree>
          </el-card>

        </el-col>
        <el-col :span="18" class="fh">
          <div class="bg-white fh">
            <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit
                      highlight-current-row style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                      @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection" width="55">
              </el-table-column>

              <el-table-column :label="'Id'" v-if="showDescription" min-width="120px">
                <template slot-scope="scope">
                  <span>{{ scope.row.id }}</span>
                </template>
              </el-table-column>

              <el-table-column min-width="80px" :label="'账号'">
                <template slot-scope="scope">
                  <span class="link-type" @click="handleUpdate(scope.row)">{{ scope.row.account }}</span>
                </template>
              </el-table-column>

              <el-table-column min-width="80px" :label="'姓名'">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>

              <el-table-column width="120px" :label="'所属部门'">
                <template slot-scope="scope">
                  <span>{{ scope.row.organizations }}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="150px" v-if='showDescription' :label="'描述'">
                <template slot-scope="scope">
                  <span style='color:red;'>{{ scope.row.description }}</span>
                </template>
              </el-table-column>

              <el-table-column class-name="status-col" :label="'状态'" width="100">
                <template slot-scope="scope">
                  <span :class="scope.row.status | statusFilter">{{
                      statusOptions.find(u => u.key ==
                        scope.row.status).display_name
                    }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" :label="'操作'" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
                  <el-button v-if="scope.row.status==0" size="mini" type="danger"
                             @click="handleModifyStatus(scope.row,1)">停用
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div> -->
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                        @pagination="handleCurrentChange"/>
          </div>
        </el-col>
      </el-row>

      <el-dialog class="dialog-mini" width="65%" v-el-drag-dialog :title="textMap[dialogStatus]"
                 :visible.sync="dialogFormVisible" v-dialogDrag :close-on-click-modal="false" top="44px">
        <div style="height: calc(65vh);overflow: auto;">
          <el-form :rules="rules" ref="dataForm" :model="temp" label-position="right">
            <el-form-item size="small" :label="'Id'" prop="id" v-show="dialogStatus=='update'" label-width="100px">
              <el-input v-model="temp.id" :disabled="true" size="small" placeholder="系统自动处理"></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'账号'" prop="account" label-width="100px">
              <el-input v-model="temp.account"></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'姓名'" label-width="100px">
              <el-input v-model="temp.name"></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'密码'" label-width="100px">
              <el-input v-model="temp.password"
                        :placeholder="dialogStatus=='update'?'如果为空则不修改密码':'如果为空则默认与账号相同'"></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'状态'" label-width="100px">
              <el-select class="filter-item" v-model="temp.status" placeholder="请选择...">
                <el-option v-for="item in  statusOptions" :key="item.key" :label="item.display_name" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="small" :label="'所属机构'" label-width="100px">
              <treeselect v-if="dialogFormVisible" :options="orgsTree" :default-expand-level="3" :multiple="true"
                          :flat="true" :open-on-click="true"
                          :open-on-focus="true" :clear-on-select="true" v-model="selectOrgs"></treeselect>
            </el-form-item>
            <el-form-item size="small" :label="'描述'" label-width="100px">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入..."
                        v-model="temp.description">
              </el-input>
            </el-form-item>
            <el-collapse v-model="activeNames">
              <el-collapse-item title="用户对应" name="1">
                <div class="lsDtlrules">
                  <el-table :data="temp.lkList" class="subtable" border fit>
                    <el-table-column type="index" fixed="left" width="50"></el-table-column>
                    <!-- <el-table-column min-width="130px" :label="'产品编码'">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lstDtl.' + scope.$index + '.mNo'" :rules="lstDtlrules.mNo"> -->
                    <!-- <auto-material ref="autoMaterial" :pvalue="scope.row.mNo" :itemkey="scope.$index" @getComponentitem="GetEditMaterial"></auto-material> -->
                    <!-- <el-input size="small" v-model="scope.row.mNo"></el-input>
                  </el-form-item>
                </span>
              </template>
            </el-table-column> -->
                    <el-table-column min-width="200" :label="'账套名称'">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lkList.' + scope.$index + '.accName'">
                            <el-input size="small" v-model="scope.row.accName"></el-input>
                          </el-form-item>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200" :label="'ERP用户'">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lkList.' +  scope.$index + '.erpUser'">
                            <auto-erp-user :cPersonName='scope.row.erpUser' :accinfoid='scope.row.accountId'
                                           @postdata="(val)=>{
                              Object.keys(val).forEach(item=>{
                                scope.row[item]=val[item]
                              })
                            }"/>
                          </el-form-item>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200" :label="'ERP用户编码'">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lkList.' +  scope.$index + '.erpUserCode'">
                            <el-input size="small" v-model="scope.row.erpUserCode" :readonly="true"></el-input>
                          </el-form-item>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200" :label="'ERP部门名称'">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lkList.' +  scope.$index + '.erpDeptName'">
                            <el-input size="small" v-model="scope.row.erpDeptName" :readonly="true"></el-input>
                          </el-form-item>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200" :label="'ERP部门编码'">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lkList.' +  scope.$index + '.erpDeptCode'">
                            <el-input size="small" v-model="scope.row.erpDeptCode" :readonly="true"></el-input>
                          </el-form-item>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200" :label="'id'" v-if="false">
                      <template slot-scope="scope">
                        <span>
                          <el-form-item :prop="'lkList.' + scope.$index + '.id'">
                            <el-input size="small" v-model="scope.row.id" :readonly="true"></el-input>
                          </el-form-item>
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </div>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog width="516px" class="dialog-mini body-small" v-el-drag-dialog :title="'分配角色'"
                 :visible.sync="dialogRoleVisible">
        <el-form ref="rolesForm" size="small" v-if="dialogRoleVisible" label-position="left">
          <el-form-item>
            <select-roles :roles="selectRoles" v-on:roles-change="rolesChange"></select-roles>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogRoleVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="acceRole">确认</el-button>
        </div>
      </el-dialog>

    </div>
  </div>

</template>

<script>
import {
  listToTreeSelect
} from '@/utils';
import * as accsssObjs from '@/api/accessObjs';
import * as users from '@/api/users';
import * as apiRoles from '@/api/roles';
import * as login from '@/api/login';
import Treeselect from '@riophae/vue-treeselect';
import autoErpUser from '@/components/AutoErpUser';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import waves from '@/directive/waves'; // 水波纹指令
import Sticky from '@/components/Sticky';
import permissionBtn from '@/components/PermissionBtn';
import SelectRoles from '@/components/SelectRoles';
import Pagination from '@/components/Pagination';
import elDragDialog from '@/directive/el-dragDialog';

export default {
  name: 'usermanager',
  components: {
    Sticky,
    permissionBtn,
    Treeselect,
    SelectRoles,
    Pagination,
    autoErpUser
  },
  directives: {
    waves,
    elDragDialog
  },
  data() {
    return {
      activeNames: ['1'],
      defaultProps: { // tree配置项
        children: 'children',
        label: 'label'
      },
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        orgId: '',
        key: undefined
      },
      apps: [],
      statusOptions: [{
        key: 1,
        display_name: '停用'
      },
      {
        key: 0,
        display_name: '正常'
      }
      ],
      showDescription: false,
      orgs: [], // 用户可访问到的组织列表
      orgsTree: [], // 用户可访问到的所有机构组成的树
      selectRoles: [], // 用户分配的角色
      temp: {
        id: undefined,
        description: '',
        organizations: '',
        organizationIds: '',
        account: '',
        name: '',
        password: '',
        status: 0,
        lkList: []
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogRoleVisible: false, // 分配角色对话框
      rules: {
        account: [{
          required: true,
          message: '账号不能为空',
          trigger: 'blur'
        }]
      },
      downloadLoading: false
    };
  },
  computed: {
    selectOrgs: {
      get: function() {
        if (this.dialogStatus === 'update') {
          return this.temp.organizationIds ? this.temp.organizationIds.split(',') : [];
        } else {
          return [];
        }
      },
      set: function(v) {
        // console.log('set org:', v)
        var _this = this;
        _this.temp.organizationIds = v.length > 0 && v.join(',') || '';
        var organizations = _this.orgs.filter((val) => {
          return _this.temp.organizationIds.indexOf(val.id) >= 0;
        }).map(u => u.label);
        this.temp.organizations = organizations.join(',');
      }
    }
  },
  filters: {
    statusFilter(status) {
      var res = 'color-success';
      switch (status) {
        case 1:
          res = 'color-danger';
          break;
        default:
          break;
      }
      return res;
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    var _this = this; // 记录vuecomponent
    login.getOrgs().then(response => {
      _this.orgs = response.result.map(function(item) {
        return {
          id: item.id,
          label: item.name,
          parentId: item.parentId || null
        };
      });
      var orgstmp = JSON.parse(JSON.stringify(_this.orgs));
      _this.orgsTree = listToTreeSelect(orgstmp);
    });
  },
  methods: {

    rowClick(row) {
      this.$refs.mainTable.clearSelection();
      this.$refs.mainTable.toggleRowSelection(row);
    },
    handleNodeClick(data) {
      this.listQuery.orgId = data.id;
      this.getList();
    },
    getAllUsers() {
      this.listQuery.orgId = '';
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBtnClicked: function(domId) {
      switch (domId) {
        case 'btnAdd':
          this.handleCreate();
          break;
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error'
            });
            return;
          }
          this.handleUpdate(this.multipleSelection[0]);
          break;
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error'
            });
            return;
          }
          this.handleDelete(this.multipleSelection);
          break;
        case 'btnAccessRole':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error'
            });
            return;
          }
          this.handleAccessRole(this.multipleSelection[0]);
          break;
        case 'btnResetPsd':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一个账号进行操作',
              type: 'error'
            });

            return;
          }
          users.get({ id: this.multipleSelection[0].id }).then((response) => {
            if (response.code === 200) {
              const tempData = response.result;
              tempData.password = '123456';
              tempData.organizationIds = this.multipleSelection[0].organizationIds;
              tempData.organizations = this.multipleSelection[0].organizations;

              users.update(tempData).then(() => {
                for (const v of this.list) {
                  if (v.id === this.temp.id) {
                    const index = this.list.indexOf(v);
                    this.list.splice(index, 1, this.temp);
                    break;
                  }
                }
                this.$notify({
                  title: '成功',
                  message: '密码重置成功',
                  type: 'success',
                  duration: 2000
                });
              });
            }
          });
          break;
        default:
          break;
      }
    },
    getList() {
      this.listLoading = true;
      users.getList(this.listQuery).then(response => {
        this.list = response.data;
        this.total = response.count;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getList();
    },
    handleModifyStatus(row, status) { // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success'
      });
      row.status = status;
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        description: '',
        organizations: '',
        organizationIds: '',
        account: '',
        name: '',
        status: 0,
        lkList: []
      };
    },
    handleCreate() { // 弹出添加框
      this.resetTemp();
      users.getUserLK({ id: '' }).then((response) => {
        if (response.code === 200) {
          this.temp.lkList = response.result.map(o => ({ ...o }));
          this.dialogStatus = 'create';
          this.dialogFormVisible = true;
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate();
          });
        }
      });
    },
    createData() { // 保存提交
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          users.add(this.temp).then((response) => {
            this.temp.id = response.result;
            this.list.unshift(this.temp);
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            });
          });
        }
      });
    },
    handleUpdate(row) { // 弹出编辑框
      this.temp = Object.assign({}, row); // copy obj
      users.get({ id: this.temp.id }).then((response) => {
        if (response.code === 200) {
          this.temp.lkList = response.result.lkList.map(o => ({ ...o }));
          this.dialogStatus = 'update';
          this.dialogFormVisible = true;
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate();
          });
        }
      });
    },
    updateData() { // 更新提交
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          users.update(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            });
          });
        }
      });
    },
    handleDelete(rows) { // 多行删除
      users.del(rows.map(u => u.id)).then(() => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        });
        rows.forEach(row => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    handleAccessRole(row) { // 分配角色
      const _this = this;
      this.temp = Object.assign({}, row); // copy obj
      apiRoles.loadForUser(this.temp.id).then(response => {
        _this.dialogRoleStatus = 'update';
        _this.dialogRoleVisible = true;
        _this.selectRoles = response.result;
        _this.$nextTick(() => {
          _this.$refs['rolesForm'].clearValidate();
        });
      });
    },
    rolesChange(val) {
      this.selectRoles = val;
    },
    acceRole() {
      accsssObjs.assign({
        type: 'UserRole',
        firstId: this.temp.id,
        secIds: this.selectRoles
      }).then(() => {
        this.dialogRoleVisible = false;
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        });
      });
    }
  }
};

</script>

<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.el-card__header {
  padding: 12px 20px;
}

.body-small.dialog-mini .el-dialog__body .el-form {
  padding-right: 0px;
  padding-top: 0px;
}

.dialog-mini .subtable .el-form-item {
  margin-bottom: 0px;
}
</style>
